import Navigation from "../Navigation";
import {
    GovBreadcrumbs, GovButton,
    GovFormControl,
    GovFormInput,
    GovFormLabel, GovFormSelect,
    GovIcon, GovPagination, GovSkeleton,
    GovSpacer, GovTabs, GovTabsItem
} from "@gov-design-system-ce/react";
import '../css/search-village.css';
import {useEffect, useState} from "react";
import {
    convertDateToDDMMYYYY,
    getFirstDayOfMonth,
    getLastDayOfMonth,
    getMonthsInRange,
    getRegionalCenterIds,
    mapDateFormat,
    mapRegionalCenter,
    parseJwt
} from "../utils/utils";
import StackedBarChartCustomConsultations411 from "../dashboardComponents/StackedBarChartCustomConsultations411";


export function Consultations411Content() {

    const alphabet = ["A", "B", "C", "Č", "D", "E", "F", "G", "H", "CH", "I", "J", "K", "L", "M", "N", "O", "P", "Q",
        "R", "Ř", "S", "Š", "T", "U", "V", "W", "X", "Y", "Z", "Ž"];

    const jwt = localStorage.getItem("jwt");
    const authority = parseJwt(jwt).role[0].authority;
    const RCid = localStorage.getItem("RCid");
    const isHeadquarters = authority === "HEADQUARTERS" || authority === "HQ_WITH_REPORT";

    const currentDate = new Date();
    const pastDate = new Date(2024, 0); // January is month 0 in JavaScript Date

    function getMonthString(date) {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0'); // getMonth() returns 0-based month, so +1 is needed
        return `${year}-${month}`;
    }

    const [regionalCenter, setRegionalCenter] = useState(isHeadquarters ? "0" : RCid);
    const [startMonth, setStartMonth] = useState(getMonthString(pastDate));
    const [endMonth, setEndMonth] = useState(getMonthString(currentDate));

    const [consultations, setConsultations] = useState(null);
    const [filteredItems, setFilteredItems] = useState(null);
    const [countsByRegionalCenter, setCountsByRegionalCenter] = useState(null);

    const [tabChosen, setTabChosen] = useState("Statistiky");
    const [letterChosen, setLetterChosen] = useState(false);
    const [expandedDescriptions, setExpandedDescriptions] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 20;
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = filteredItems ? filteredItems.slice(indexOfFirstItem, indexOfLastItem) : null;

    const months = getMonthsInRange(startMonth, endMonth);
    const regionalCentersToShow = getRegionalCenterIds(regionalCenter);

    const handlePageChange = (event) => {
        setCurrentPage(event.detail.pagination.currentPage);
    };

    const handleTabChange = (event) => {
        setTabChosen(event.detail.label);
    };

    const handleRegionalCenterChange = (event) => {
        setRegionalCenter(event.target.value);
    };

    const handleStartMonthChange = (event) => {
        setStartMonth(event.target.value);
    };

    const handleEndMonthChange = (event) => {
        setEndMonth(event.target.value);
    };

    function getConsultationTown(consultation) {
        return consultation.town ? consultation.town : null;
    }

    function getDescriptionPreview(html, maxLength = 150) {
        if (!html) return '';
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = html;
        const allExternalDivs = tempDiv.querySelectorAll('div[class^="ExternalClass"]');
        const contentHolder = allExternalDivs.length > 0 ? allExternalDivs[allExternalDivs.length - 1] : tempDiv;
        const text = contentHolder.textContent || '';
        return text.length > maxLength ? text.substring(0, maxLength) + ' ...' : text;
    }

    function toggleDescription(consultationId) {
        if (expandedDescriptions.includes(consultationId)) {
            setExpandedDescriptions(expandedDescriptions.filter(id => id !== consultationId));
        } else {
            setExpandedDescriptions([...expandedDescriptions, consultationId]);
        }
    }

    const handleSearchChange = (event) => {
        setCurrentPage(1)
        setLetterChosen(false)
        filterConsultations(consultations, event.target.value, false);
    };

    const handleLetterClick = (letter) => {
        setCurrentPage(1)
        setLetterChosen(letter !== '')
        filterConsultations(consultations, letter, letter !== '');
    };

    function filterConsultations(consultationsToFilter, term, filterByFirstLetter) {
        if (!consultationsToFilter) {
            return;
        }
        if (!term) {
            setFilteredItems(sortConsultations(consultationsToFilter, sortColumn, sortOrder));
            return;
        }
        const filtered = consultationsToFilter.filter(consultation => {
            const town = getConsultationTown(consultation);
            if (!town) {
                return false;
            }
            if (filterByFirstLetter) {
                return town.name.toString().toLowerCase().startsWith(term.toLowerCase());
            }
            return town.name.toString().toLowerCase().includes(term.toLowerCase()) ||
                town.id.toString().toLowerCase().includes(term.toLowerCase());
        });
        setFilteredItems(sortConsultations(filtered, sortColumn, sortOrder));
    }

    const [sortColumn, setSortColumn] = useState('date');
    const [sortOrders, setSortOrders] = useState({id: 'desc', town: 'desc', townId: 'desc', date: 'desc'});
    const sortOrder = sortOrders[sortColumn];

    function sortConsultations(consultationsToSort, column, order) {
        const sortedConsultations = [...consultationsToSort];
        sortedConsultations.sort((a, b) => {
            let comparison;
            if (column === 'town') {
                const townA = getConsultationTown(a);
                const townB = getConsultationTown(b);
                comparison = (townA ? townA.name.toString() : '').localeCompare(townB ? townB.name.toString() : '');
            } else if (column === 'id') {
                comparison = a.id - b.id;
            } else if (column === 'townId') {
                const townA = getConsultationTown(a);
                const townB = getConsultationTown(b);
                comparison = (townA ? townA.id : 0) - (townB ? townB.id : 0);
            } else {
                comparison = new Date(a[column]) - new Date(b[column]);
            }
            return order === 'asc' ? comparison : -comparison;
        });
        return sortedConsultations;
    }

    useEffect(() => {
        if (filteredItems) {
            setFilteredItems(sortConsultations(filteredItems, sortColumn, sortOrder));
        }
    }, [sortColumn, sortOrders]);

    function sortButton(column) {
        const nextOrder = sortOrders[column] === 'asc' ? 'desc' : 'asc';
        return (
            <GovButton onGov-click={() => {
                setSortColumn(column);
                setSortOrders({...sortOrders, [column]: nextOrder});
            }}
                       wcag-label="What exactly happens when you click?" variant="primary"
                       type="link" size="xs" loading="false">

                <GovIcon className="ml-5" type="basic"
                         name={sortOrders[column] === 'asc' ? "chevron-up" : "chevron-down"}
                         slot="left-icon"></GovIcon> </GovButton>
        );
    }

    const fetchConsultations = () => {
        setConsultations(null);
        setFilteredItems(null);
        setCurrentPage(1);
        let request = `?dateFrom=${getFirstDayOfMonth(startMonth)}&dateTo=${getLastDayOfMonth(endMonth)}`;
        if (regionalCenter !== "0") {
            request += `&rcId=${regionalCenter}`;
        }
        fetch(process.env.REACT_APP_API_URL + "/consultations" + request, {
            headers: {
                'Authorization': `Bearer ${jwt}`
            }
        })
            .then(response => {
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                return response.json();
            })
            .then(jsonData => {
                setConsultations(jsonData);
                setFilteredItems(sortConsultations(jsonData, sortColumn, sortOrder));
            })
            .catch(error => {
                console.error('Error fetching data:', error);
            });
    };

    const fetchConsultationsCounts = () => {
        setCountsByRegionalCenter(null);
        Promise.all(regionalCentersToShow.map(regionalCenterId =>
            fetch(process.env.REACT_APP_API_URL + `/consultations/counts?rcId=${regionalCenterId}&from=${startMonth}&to=${endMonth}`, {
                headers: {
                    'Authorization': `Bearer ${jwt}`
                }
            })
                .then(response => {
                    if (!response.ok) {
                        throw new Error(`HTTP error! status: ${response.status}`);
                    }
                    return response.json();
                })
                .then(jsonData => ({regionalCenterId: regionalCenterId, counts: jsonData}))
        ))
            .then(results => {
                const countsByRc = {};
                results.forEach(result => {
                    countsByRc[result.regionalCenterId] = {};
                    result.counts.forEach(count => {
                        countsByRc[result.regionalCenterId][count.yearMonth] = count.consultationsCount;
                    });
                });
                setCountsByRegionalCenter(countsByRc);
            })
            .catch(error => {
                console.error('Error fetching data:', error);
            });
    };

    useEffect(() => {
        setLetterChosen(false);
        fetchConsultations();
        fetchConsultationsCounts();
    }, [regionalCenter, startMonth, endMonth]);

    function getCount(regionalCenterId, yearMonth) {
        if (!countsByRegionalCenter || !countsByRegionalCenter[regionalCenterId]) {
            return 0;
        }
        return countsByRegionalCenter[regionalCenterId][yearMonth] ? countsByRegionalCenter[regionalCenterId][yearMonth] : 0;
    }

    function getCountsSumOfRegionalCenter(regionalCenterId) {
        return months.reduce((total, yearMonth) => total + getCount(regionalCenterId, yearMonth), 0);
    }

    function getCountsSumOfMonth(yearMonth) {
        return regionalCentersToShow.reduce((total, regionalCenterId) => total + getCount(regionalCenterId, yearMonth), 0);
    }

    function getCountsChartData() {
        return months.map(yearMonth => {
            const monthData = {name: mapDateFormat(yearMonth)};
            regionalCentersToShow.forEach(regionalCenterId => {
                monthData[mapRegionalCenter(regionalCenterId)] = getCount(regionalCenterId, yearMonth);
            });
            return monthData;
        });
    }

    return (
        <div>
            <Navigation active={"consultation411"}/>
            <div className="gov-container">
                <GovBreadcrumbs className="gov-breadcrumbs-login" wcag-label="You are in the following level">
                    <ul>
                        <li>
                            <GovIcon type="basic" name="chevron-right"></GovIcon>
                            <a href="/">Úvod</a></li>
                        <li>
                            <GovIcon type="basic" name="chevron-right"></GovIcon>
                            <strong>Konzultace 4.1.1</strong>
                        </li>
                    </ul>
                </GovBreadcrumbs>
                <div className="gov-container">
                    <div className="gov-container__content">

                        <div
                            className="gov-title--beta">Konzultace 4.1.1: {isHeadquarters && regionalCenter === "0" ? "" : mapRegionalCenter(regionalCenter)}</div>

                        <GovTabs onGov-change={handleTabChange} type="chip" variant="primary"
                                 wcag-label="Basic information about the gov.cz design system">
                            <GovTabsItem label="Statistiky"></GovTabsItem>
                            <GovTabsItem label="Přehled"></GovTabsItem>
                        </GovTabs>
                        <GovSpacer size="s"></GovSpacer>

                        <div className="gov-flexbox gov-flexbox--justify-start flex-wrap">
                            {isHeadquarters &&
                                <GovFormControl>
                                    <GovFormSelect size="s" placeholder="Regionální centrum"
                                                   onGov-change={handleRegionalCenterChange} value={regionalCenter}>
                                        <option disabled="disabled" value="">Vyberte regionální centrum</option>
                                        <option value="0">Všechna regionální centra</option>
                                        <option value="1">Moravskoslezský kraj</option>
                                        <option value="2">Středočeský kraj a Praha</option>
                                        <option value="3">Ústecký a Karlovarský kraj</option>
                                        <option value="4">Královehradecký a Liberecký kraj</option>
                                        <option value="5">Pardubický kraj a kraj Vysočina</option>
                                        <option value="6">Jihočeský kraj a Plzeňský kraj</option>
                                        <option value="7">Zlínský a Jihomoravský kraj</option>
                                        <option value="8">Olomoucký kraj</option>
                                    </GovFormSelect>
                                    <GovFormLabel slot="top" size="s">Regionální centrum</GovFormLabel>
                                </GovFormControl>
                            }
                            <GovFormControl className="ml-5">
                                <GovFormInput value={startMonth} onGov-input={handleStartMonthChange} size="s"
                                              variant="secondary" input-type="month"></GovFormInput>
                                <GovFormLabel slot="top" size="s">Měsíc od:</GovFormLabel>
                            </GovFormControl>
                            <GovFormControl className="ml-5">
                                <GovFormInput value={endMonth} onGov-input={handleEndMonthChange} size="s"
                                              variant="secondary" input-type="month"></GovFormInput>
                                <GovFormLabel slot="top" size="s">Měsíc do:</GovFormLabel>
                            </GovFormControl>
                        </div>
                        <GovSpacer size="m"></GovSpacer>

                        <div className={tabChosen === "Statistiky" ? "visible" : "hidden"}>
                            {countsByRegionalCenter ?
                                <div>
                                    <div className="table-consultations411-counts-container">
                                    <table cellSpacing="0" cellPadding="0" className="table-consultations411-counts">
                                        <thead>
                                        <tr>
                                            <th>Regionální centrum</th>
                                            {months.map((yearMonth) => (
                                                <th key={yearMonth}>{mapDateFormat(yearMonth)}</th>
                                            ))}
                                            <th>Celkem</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {regionalCentersToShow.map((regionalCenterId) => (
                                            <tr key={regionalCenterId}>
                                                <td className="first">{mapRegionalCenter(regionalCenterId)}</td>
                                                {months.map((yearMonth) => (
                                                    <td key={yearMonth}>{getCount(regionalCenterId, yearMonth)}</td>
                                                ))}
                                                <td><strong>{getCountsSumOfRegionalCenter(regionalCenterId)}</strong></td>
                                            </tr>
                                        ))}
                                        <tr>
                                            <td className="first"><strong>Celkem</strong></td>
                                            {months.map((yearMonth) => (
                                                <td key={yearMonth}><strong>{getCountsSumOfMonth(yearMonth)}</strong></td>
                                            ))}
                                            <td>
                                                <strong>{regionalCentersToShow.reduce((total, regionalCenterId) => total + getCountsSumOfRegionalCenter(regionalCenterId), 0)}</strong>
                                            </td>
                                        </tr>
                                        </tbody>
                                    </table>
                                    </div>
                                    <GovSpacer size="s"></GovSpacer>
                                    <StackedBarChartCustomConsultations411
                                        data={getCountsChartData()}
                                        keys={regionalCentersToShow.map(regionalCenterId => mapRegionalCenter(regionalCenterId))}
                                        title={"Vývoj počtu konzultací 4.1.1 za zadané období"}
                                        width={"100%"}
                                        height={300}></StackedBarChartCustomConsultations411>
                                </div>
                                :
                                <GovSkeleton wcag-label="Loading content of page" variant="secondary" shape="text"
                                             animation="progress" count="1" height="300px"></GovSkeleton>
                            }
                        </div>

                        <div className={tabChosen === "Přehled" ? "visible" : "hidden"}>
                        <div className="gov-flexbox search-row-width">
                            <GovFormInput onGov-input={handleSearchChange}
                                          placeholder="Zadejte název nebo kód obce" size="m"
                                          variant="secondary">
                                <GovIcon type="basic" name="search" slot="right-icon"></GovIcon>
                            </GovFormInput>
                        </div>
                        <div className="gov-container gov-flexbox gov-alphabet">
                            {alphabet.map((letter) => (
                                <GovButton key={letter} wcag-label="What exactly happens when you click?"
                                           variant="primary" type="link"
                                           size="m" onGov-click={() => handleLetterClick(letter)}>{letter}
                                </GovButton>
                            ))}
                            {letterChosen && <GovButton onGov-click={() => {
                                handleLetterClick('')
                            }} wcag-label="What exactly happens when you click?" variant="primary"
                                                        size="xs">Odstranit výběr
                            </GovButton>}
                        </div>
                        <GovSpacer size="l"></GovSpacer>
                        {currentItems ?
                            <table cellSpacing="0" cellPadding="0" className="table-consultations411">
                                <thead>
                                <tr>
                                    <th><span className="th-wrapped-label">ID konzultace</span>
                                        {sortButton('id')}
                                    </th>
                                    <th className="w-200px">Obec
                                        {sortButton('town')}
                                    </th>
                                    <th className="w-100px">Kód obce
                                        {sortButton('townId')}
                                    </th>
                                    <th><span className="th-wrapped-label">Datum konzultace</span>
                                        {sortButton('date')}
                                    </th>
                                    <th>Popis</th>
                                </tr>
                                </thead>
                                <tbody>
                                {currentItems.map((row, index) => {
                                    const town = getConsultationTown(row);
                                    const description = getDescriptionPreview(row.description);
                                    return (
                                        <tr key={index}>
                                            <td className="first">{row.id}</td>
                                            <td>
                                                {town ?
                                                    <a href={`/towns/${town.id.toString().length > 6 ? "collective/" : ""}detail/${town.id}`}>{town.name}</a>
                                                    :
                                                    "Obec není uvedena"
                                                }
                                            </td>
                                            <td>{town ? town.id : ""}</td>
                                            <td>{row.date ? convertDateToDDMMYYYY(row.date) : "Konzultace se neuskutečnila (jedná se pouze o žádost o konzultaci)"}</td>
                                            <td>
                                                <div
                                                    dangerouslySetInnerHTML={{
                                                        __html: expandedDescriptions.includes(row.id)
                                                            ? row.description
                                                            : description
                                                    }}
                                                ></div>
                                                {description.endsWith(' ...') &&
                                                    <span>
                                                        <button onClick={() => toggleDescription(row.id)}>
                                                            {expandedDescriptions.includes(row.id) ? "Skrýt popis" : "Zobrazit celý popis"}
                                                        </button>
                                                    </span>
                                                }
                                            </td>
                                        </tr>
                                    );
                                })}
                                </tbody>
                            </table>
                            : (
                                <GovSkeleton wcag-label="Loading content of page" variant="secondary" shape="text"
                                             animation="progress" count="1" width="300px" height="30px"></GovSkeleton>
                            )}
                            <div className="pagination-container">
                                {filteredItems ? (
                                    <GovPagination onGov-page={handlePageChange} variant="primary" size="s"
                                                   type="button"
                                                   current={currentPage} total={filteredItems.length}
                                                   page-size={itemsPerPage}
                                                   max-pages="4" wcag-label="Main paging"
                                                   wcag-page-label="Page"></GovPagination>
                                ) : (
                                    <GovSkeleton wcag-label="Loading content of page" variant="secondary" shape="text"
                                                 animation="progress" count="1" width="300px"
                                                 height="30px"></GovSkeleton>
                                )}
                            </div>
                        </div>

                    </div>

                </div>
            </div>
        </div>
    )
}
